export default __webpack_public_path__ + "static/media/currency_cloud.c5b36fc5.svg";